module.exports = __webpack_public_path__ + "static/box1-13693d72b58229e2feb590c797993fda.jpg";